















import Vue from 'vue';

export default Vue.extend({
  name: 'menu-component',
  methods: {
    onCloseClick: function() {
      this.$emit('input', false);
    },
    onLogoutClick: function() {
      // This will redirect to the logout page of the provider.
      this.$store.dispatch('LOGOUT');
      this.$emit('input', false);
    }
  },
  computed: {
    menuVisible: function() {
      return !!this.$attrs.value;
    }
  }
});
